module.exports = __webpack_public_path__ + "img/press_dash.df0eb62a.svg";